import React from "react"
import { Link } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage } from "gatsby-plugin-image"
import { useTranslation } from "react-i18next"
import { gtmTracking } from "@/utils/gtm-tracking"

const StackingContentBlock = ({
  index,
  kicker,
  title,
  description,
  image,
  link,
  playlistId,
}) => {
  const { t } = useTranslation()
  return (
    <div className="stacking__content-block" key={index}>
      <div className="p-8 md:p-16 stacking__content-block__content">
        <div>
          <h2 className="stacking__content-block__kicker mb-0 p">{kicker}</h2>

          <h3 className="mb-0">{title}</h3>

          {description && <p className="mb-0 mt-6 p--lg">{description}</p>}
        </div>

        {link && (
          <Link
            to={link.url}
            className="btn btn--lg mt-4 md:mt-8"
            aria-label={`${t("common.learn-more")} - ${kicker}`}
            onClick={() =>
              gtmTracking("CTA Click", "Learn More", `${link.url}`)()
            }
          >
            {link.buttonText || t("common.learn-more")}
          </Link>
        )}
      </div>

      {playlistId ? (
        <div className="stacking__content-block__image">
          <iframe
            src={`https://open.spotify.com/embed/playlist/${playlistId}?utm_source=generator&theme=0`}
            width="100%"
            height="100%"
            frameBorder="0"
            allowfullscreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>
        </div>
      ) : (
        <div className="stacking__content-block__image">
          <GatsbyImage
            image={image.src}
            alt={image.alt}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "8px",
              objectFit: "cover",
            }}
          />
        </div>
      )}
    </div>
  )
}

export default StackingContentBlock
